import SelectInputWithLabelT from '@components/tailwind-components/Input/SelectInputWithLabelT';
import type { Control, FieldValues, Path } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useAgents } from '../../../../../hooks/settings/agents/useAgents';
import { useInboxes } from '../../../../../hooks/settings/inboxes/useInboxes';
import { useWebclient } from '../../../../../hooks/settings/webclients/useWebclient';

type NameSelectorProps<T extends FieldValues> = {
  name: Path<T>;
  control: Control<T>;
  disabled?: boolean;
  type: 'agent' | 'inbox' | 'webclient';
};

export function TargetSelector<T extends FieldValues>({
  name,
  control,
  disabled,
  type,
}: NameSelectorProps<T>) {
  const { t } = useTranslation();
  const { agents } = useAgents();
  const { inboxes } = useInboxes();
  const { webclient } = useWebclient();

  const mapSelectableValues = (type: string) => {
    switch (type) {
      case 'inbox':
        return inboxes.map((inbox) => ({
          value: inbox.identifier,
          description: inbox.name,
        }));
      case 'agent':
        return agents.map((agent) => ({
          value: agent.id,
          description: agent.email,
        }));
      case 'webclient':
        return webclient.configs.map((config) => ({
          value: config.identifier,
          description: config.name,
        }));
      default:
        return [];
    }
  };

  const selectableValues = mapSelectableValues(type);

  return (
    <div className='flex flex-col w-full'>
      <SelectInputWithLabelT
        label={t('handover-settings.interval.type')}
        field={name}
        values={selectableValues}
        control={control}
        options={{
          disabled,
        }}
      />
    </div>
  );
}

export default TargetSelector;
